import type { CSSProperties } from 'react';
import WebhookSigningSecretIconSvg from '../../assets/icons/webhook_signing_secret.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const WebhookSigningSecretIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return (
        <WebhookSigningSecretIconSvg className={className} style={iconStyle} onClick={onClick} />
    );
};

export default WebhookSigningSecretIcon;
